import { render, staticRenderFns } from "./select.vue?vue&type=template&id=2ed88652&scoped=true&lang=pug&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=2ed88652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed88652",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsLottie: require('/home/ubuntu/nuxt/bonkers/releases/20231002092431/components/widgets/lottie.vue').default})
